export default "__VITE_ASSET__6d11ff69__"